import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Table,
  Spin,
  Form,
  Select,
  Tooltip,
  Modal,
  message,
  Button,
} from "antd";
import styled from "@emotion/styled";
import AttendanceBarChart from "molecules/AttendanceBarChart";
import LocationBasedPresentStaff from "molecules/LocationBasedPresentStaff";
import { CALL_API } from "common/API";
import { getColor, LEAVE_ICON, STATUS_CODE } from "common/Constants";
import { includes, concat, orderBy, some } from "lodash";
import COLORS from "common/Colors";
import moment from "moment";
import LeaveFormModel from "organisms/LeaveFormModel";
import ViewMore from "organisms/ViewMore";
import { EyeFilled, BellFilled } from "@ant-design/icons";
import { getMySqlDate } from "utils/Date";
import LeaveDonutChart from "molecules/LeaveDonutChart";
import DepartmentStaffLeaveBalance from "molecules/DepartmentStaffLeaveBalance";
import { getLoadingRoute, getCRMManagingOfficeList, getLocations } from "redux/selectors";
import { connect, useSelector } from "react-redux";
import { uniqBy } from "lodash";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import { CountryFilterResourcePlanning } from "common/Constants";
import { CSVLink } from "react-csv";
import { reduce } from "lodash";
import { dateInDetail, getKenyanDateTime } from "utils/Date";


const StyledRow = styled(Row)`
  padding-top: 20px;
`;

const StyledLeaveContainer = styled.div`
  padding: 12px 20px 20px 20px !important;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px;
  border-radius: 5px !important;
  padding-bottom: 25px;
  margin: 0px !important;
`;

const StyledChartContainer = styled.div`
  padding: 20px !important;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px;
  border-radius: 5px !important;
  padding-bottom: 25px;
  margin: 0px !important;
`;

const StyledTitle = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: #141414;
  margin-right: auto;
`;
const StyledTable = styled(Table)`
  padding-top: 20px;
  table {
    width: 100% !important;
  }
  tr.ant-table-row:hover > td {
    background: hsla(0, 0%, 90%, 0.5);
    cursor: pointer;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
  }
  .ant-table-cell {
    padding: 20px;
  }
  .normal-column {
    min-width: 300px;
    white-space: normal;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: 600;
    font-size: 0.9rem;
    color: ${COLORS.SECONDARY_BLACK};
    white-space: nowrap;
  }
  .non-white {
    background: #f9f9f9;
  }
`;

const StyledLoader = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const ButtonOutlined = styled(Button)`
  padding: 5px 20px;
  border: 1px solid ${COLORS.PRIMARY};
  border-radius: 5px;
  background: transparent;
  font-weight: normal;
  color: ${COLORS.PRIMARY};
  white-space: nowrap;

  &:hover {
    border: 1px solid ${COLORS.PRIMARY};
    background: #f1f3f4;
    color: ${COLORS.PRIMARY};
  }
  &:focus {
    border: 1px solid ${COLORS.PRIMARY};
    background: #f1f3f4;
    color: ${COLORS.PRIMARY};
  }
  @media (max-width: 900px) {
    margin: 10px 0px;
  }
`;

function HrDashboard({
  ClientId,
  employeeid,
  selectedDepartmentId,
  userRoleId,
  departmentList,
  roleList,
  AllDepartmentList,
  Menulist,
  leaveCategoryList,
  userList,
  userInfo,
  loadingRoute,
  tabId,
  locationList
}) {
  const [leaveList, setLeaveList] = useState([]);
  const [leaveCatgeory, setLeaveCatgeory] = useState([]);
  const [displayTaskLoader, setDisplayTaskLoader] = useState(false);
  const [displayLeaveModal, toggleDisplayLeaveModal] = useState(false);
  const [leaveDetails, setLeaveDetails] = useState({});
  const [leaveID, setLeaveID] = useState();
  const [leaveUserId, setLeaveUserId] = useState();
  const [havingCancel, sethavingCancel] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [leaveSummary, setLeaveSummary] = useState({});
  const [displayLeaveReportLoader, toggleLeaveReportLoader] = useState(false);
  const [staffDepartmentLeaveModal, toggleStaffDepartmentLeaveModal] =
    useState(false);
  const [selectedLeaveTypeId, setSelectedLeaveTypeId] = useState("");
  const [selectedLeaveType, setSelectedLeaveType] = useState("");
  const crmManagingOfficeList = useSelector(getCRMManagingOfficeList)
  const [form] = Form.useForm();
  const filteruser = userList?.filter(
    (item) => item?.userid === userInfo.userid
  );
  const [selectedManagingOffice, setSelectedManagingOffice] = useState(filteruser[0]?.managingoffice);
  const [CSVDepartmentLeave, setCSVDepartmentLeave] = useState([]);
  const [availableConsumed, setAvailableConsumed] = useState([]);


  console.log(availableConsumed, "availableConsumedavailableConsumed")
  const containerRef = useRef(null);
  const csvLinkDepartment = useRef();

  const locationMap = locationList.reduce((acc, loc) => {
    acc[loc.location_id] = loc;
    return acc;
  }, {});

  const buildOverallLeaveSummary = () => {
    if (!Array.isArray(availableConsumed)) return [];

    const map = {};

    availableConsumed.forEach((item) => {
      const key = String(item.leaveCategoryId);

      if (!map[key]) {
        map[key] = {
          id: key,
          categoryName: item.leaveCategoryName,
          available: 0,
          consumed: 0,
          carryforward: 0,
        };
      }

      map[key].available += Number(item.available ?? 0);
      map[key].consumed += Number(item.consumed ?? 0);
      map[key].carryforward += Number(item.carryforward ?? 0);
    });

    return Object.values(map);
  };

  useEffect(() => {
    const summary = buildOverallLeaveSummary();
    setLeaveSummary(summary);
  }, [availableConsumed]);

  useEffect(() => {
    const summary = buildOverallLeaveSummary();
    setLeaveSummary(summary);
  }, [availableConsumed]);


  // const filterLeavecategory = filteredLeaveCategory?.filter((val) =>
  //   val?.locationId?.includes(filteruser[0]?.baselocationid)
  // );

  const filterUser = userList?.find((val) => val?.userid === userInfo?.userid);


  // useEffect(() => {
  //   let leaveStatistics = {};

  //   leaveCategoryList?.forEach((category) => {
  //     leaveStatistics[category.leaveCategoryId] = {
  //       available: 0,
  //       consumed: 0,
  //       location: category?.locationId
  //     };
  //   });



  //   const approvedLeaves = leaveCatgeory.filter((item) => {
  //     const userid = item.userid;
  //     const user = userList.find((user) =>
  //       filterUser?.managingoffice?.includes("Head Office")
  //         ? user.userid === userid
  //         : user.userid === userid &&
  //         user?.managingoffice === filterUser?.managingoffice
  //     );
  //     const isActiveUser = user?.statusid === "1";

  //     return isActiveUser && item.status_id === "5";
  //   });

  //   approvedLeaves.forEach((leave) => {
  //     const leaveCategoryName = leave?.leave_category_id;
  //     if (!leaveStatistics[leaveCategoryName] || !leaveStatistics[leaveCategoryName]?.location?.includes(leave?.baselocationid)) {
  //       return;
  //     }
  //     leaveStatistics[leaveCategoryName].consumed += parseFloat(
  //       leave.number_of_days
  //     );
  //   });

  //   const updatedLeaveData = leaveCategoryList?.map((category) => {


  //     const categoryName = category.leaveCategoryName;

  //     const userCount = leaveCategoryList?.filter((user) => {
  //       const eligibleGender = category.eligible.toLowerCase();
  //       if (eligibleGender === "both") {
  //         return true;
  //       } else {
  //         const userGender = user.gender?.toLowerCase();
  //         return eligibleGender === userGender;
  //       }
  //     }).length;

  //     return {
  //       categoryName: categoryName,
  //       id: category.leaveCategoryId,
  //       data: [
  //         {
  //           type: "available",
  //           value:
  //             // userCount * parseInt(category.numberOfLeaves) || 0,
  //             userCount * parseInt(category.numberOfLeaves) || 0,
  //         },
  //         {
  //           type: "consumed",
  //           value: leaveStatistics[category.leaveCategoryId]?.consumed || 0,
  //         },
  //       ],
  //     };
  //   });





  //   // const updatedLeaveData = leaveCatgeory?.map((category) => {
  //   //   const categoryName = category?.leave_category_name;

  //   //   // 1️⃣ Get all active users
  //   //   const activeUsers = userList.filter(
  //   //     (user) => user.statusid === "1"
  //   //   );

  //   //   const userCount = activeUsers.length;

  //   //   return {
  //   //     categoryName,
  //   //     id: category.leaveCategoryId,
  //   //     data: [
  //   //       {
  //   //         type: "available",
  //   //         value: userCount * Number(category.numberOfLeaves || 0),
  //   //       },
  //   //       {
  //   //         type: "consumed",
  //   //         value:
  //   //           leaveStatistics?.[category.leaveCategoryId]?.consumed || 0,
  //   //       },
  //   //     ],
  //   //   };
  //   // });


  //   setLeaveSummary(updatedLeaveData);
  // }, [leaveCatgeory, userList, leaveCategoryList, selectedManagingOffice]);

  const handleFormChange = (value) => {
    setSelectedManagingOffice(value || "");
    getLeaveList(value);
  };

  const handleFormChangeLeave = (value) => {

    setSelectedManagingOffice(value || "");
    // getLeaveListCategories(value);
    getLeaveAvailableConsumed(value);
  };

  useEffect(() => {
    if (!Array.isArray(availableConsumed)) return;

    const summary = {};

    availableConsumed.forEach((item) => {
      const key = String(item.leaveCategoryId);

      if (!summary[key]) {
        summary[key] = {
          id: key,
          categoryName: item.leaveCategoryName,
          available: 0,
          consumed: 0,
          carryforward: 0,
        };
      }

      summary[key].available += Number(item.available || 0);
      summary[key].consumed += Number(item.consumed || 0);
      summary[key].carryforward += Number(item.carryforward || 0);
    });

    setLeaveSummary(Object.values(summary));
  }, [availableConsumed]);



  const openDetailWindow = (name, id) => {
    setSelectedLeaveTypeId(id);
    setSelectedLeaveType(`${name} Report`);
    toggleStaffDepartmentLeaveModal(true);
  };

  useEffect(() => {
    form.setFieldsValue({
      managingoffice: []
    });
  }, []);

  useEffect(() => {
    if (loadingRoute || tabId) {
      getLeaveList();
      getLeaveAvailableConsumed()
      // getLeaveListCategories();
    }
  }, [loadingRoute, tabId]);

  function getDates() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();

    const startDate = new Date(currentYear - 2, 0, 1);
    const endDate = new Date(currentYear + 1, 11, 31);

    return {
      startDate,
      endDate,
    };
  }

  const dates = getDates();

  const ApproveOk = async (reason) => {
    return new Promise(async (resolve) => {
      await approveRejectCancelLeave2(5, reason, havingCancel);
      resolve();
    }).catch((err) => console.log("[ApproveOk] Error-->", err));
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleOk = () => {
    setLoading(true);
    ApproveOk();
  };

  const getLeaveList = async (country) => {
    return new Promise(async (resolve, reject) => {
      setLeaveList([]);

      setDisplayTaskLoader(true);
      const { code, leaves = [] } = await CALL_API(
        `leave-list/${ClientId}`,
        "post",
        {
          status_id: "4",
          // department_id: selectedDepartmentId,
          officesupervisorid: [""],
          start_date: dates.startDate,
          end_date: dates.endDate,
          country: country ? [country] : filteruser[0]?.managingoffice,
          ...(filteruser[0]?.roleid?.includes("2") && { superAdmin: true })
        }
      );

      setDisplayTaskLoader(false);
      if (includes([STATUS_CODE.SUCCESS, STATUS_CODE.RECORD_NOT_FOUND], code)) {
        setLeaveList(leaves.reverse());

        resolve(leaves);
      } else {
        reject([]);
      }
    });
  };

  const getLeaveListCategories = async (country) => {
    return new Promise(async (resolve, reject) => {
      setLeaveCatgeory([]);

      if (selectedDepartmentId) {
        toggleLeaveReportLoader(true);
        const { code, response = [] } = await CALL_API(
          `employee/allleave`,
          "post",
          {
            clientId: ClientId,
            year: new Date().getFullYear().toString(),
            country: country ? [country] : filteruser[0]?.managingoffice,
          }
        );

        toggleLeaveReportLoader(false);
        if (
          includes([STATUS_CODE.SUCCESS, STATUS_CODE.RECORD_NOT_FOUND], code)
        ) {
          setLeaveCatgeory(response);

          resolve(response);
        } else {
          reject([]);
        }
      } else {
        reject([]);
      }
    });
  };

  const getLeaveAvailableConsumed = async (country) => {
    const payload =
    {
      userId: filteruser?.userid,
      year: dateInDetail(getKenyanDateTime()).year,
      requestType: "all",
      country: country ? [country] : filteruser[0]?.managingoffice,
      ...(filteruser[0]?.roleid?.includes("2") && { superAdmin: true })

    }

    try {
      // const { response } = await CALL_API(`owner-leave/${ClientId}`, "get", {});
      const response = await CALL_API(
        `employee-leave-details/${ClientId}`,
        "post",
        payload
      );
      setAvailableConsumed(response?.response);
    } catch (error) {
      console.log("[getLeaveList], Error-->", error);
    }
  };

  const approveRejectCancelLeave2 = async (
    statusId,
    declined_reason = "",
    is_leave_cancel_request
  ) => {
    return new Promise(async (resolve) => {
      const { code } = await CALL_API(
        `approve-reject-cancel-leave/${ClientId}`,
        "post",
        {
          departmentId: selectedDepartmentId,
          user_leave_id: leaveID,
          leave_applied_userid: leaveUserId,
          status_id: statusId.toString(),
          declined_reason,
          is_cancel_request: is_leave_cancel_request,
          start_date: leaveDetails?.new_start_date
            ? getMySqlDate(leaveDetails?.new_start_date)
            : getMySqlDate(leaveDetails?.start_date),
          end_date: leaveDetails?.new_end_date
            ? getMySqlDate(leaveDetails?.new_end_date)
            : getMySqlDate(leaveDetails?.end_date),
        }
      );

      if (code === STATUS_CODE.SUCCESS) {
        setLoading(false);
        setIsModalOpen(false);
        message.success(`Leave has been approved`);
        getLeaveList();
      } else {
        message.error(`Something went wrong. Please try again.`);
      }
      resolve();
    });
  };

  const paginationOptions = {
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    pageSize: 10,
    showSizeChanger: false,
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "fullname",
      key: "fullname",
      width: "10%",
      sorter: (a, b) => a.fullname.localeCompare(b.fullname),
    },
    {
      title: "Employee ID",
      dataIndex: "employeeid",
      key: "employeeid",
      width: "7%",
      sorter: (a, b) => a.employeeid.localeCompare(b.employeeid),
    },
    // {
    //   title: "Department",
    //   dataIndex: "department_name",
    //   key: "department_name",
    //   width: "10%",
    // },
    {
      title: "Start Date",
      dataIndex: "start_date",
      key: "start_date",
      width: "10%",
      sorter: (a, b) => new Date(a.start_date) - new Date(b.start_date),
      render: (_, record) => {
        if (
          record.new_start_date === "null" ||
          record.new_start_date === "" ||
          record.new_start_date === null
        ) {
          const dateFormat = moment(record.start_date).format("DD MMM YYYY");
          const getdayAlone = moment(record.start_date).format("dddd");
          return `${dateFormat} - ${getdayAlone}`;
        } else {
          const dateFormat = moment(record.new_start_date).format(
            "DD MMM YYYY"
          );
          const getdayAlone = moment(record.new_start_date).format("dddd");

          return `${dateFormat} - ${getdayAlone}`;
        }
      },
    },

    {
      title: "End Date",
      dataIndex: "end_date",
      key: "end_date",
      width: "10%",
      sorter: (a, b) => new Date(a.end_date) - new Date(b.end_date),
      render: (_, record) => {
        if (
          record.new_end_date === "null" ||
          record.new_end_date === "" ||
          record.new_end_date === null
        ) {
          const dateFormat = moment(record.end_date).format("DD MMM YYYY");
          const getdayAlone = moment(record.end_date).format("dddd");

          return `${dateFormat} - ${getdayAlone}`;
        } else {
          const dateFormat = moment(record.new_end_date).format("DD MMM YYYY");
          const getdayAlone = moment(record.new_end_date).format("dddd");

          return `${dateFormat} - ${getdayAlone}`;
        }
      },
    },
    {
      title: "Days",
      dataIndex: "number_of_days",
      key: "number_of_days",
      width: "7%",
      sorter: (a, b) => parseFloat(a.number_of_days) - parseFloat(b.number_of_days),
      render: (_, record) => {
        if (
          record.new_number_of_days === null ||
          record.new_number_of_days === "" ||
          record.new_number_of_days === "null"
        ) {
          return record.number_of_days;
        } else {
          return record.new_number_of_days;
        }
      },
    },
    {
      title: "Leave Type",
      dataIndex: "leave_category_name",
      key: "leave_category_name",
      width: "10%",
      sorter: (a, b) => a.leave_category_name.localeCompare(b.leave_category_name),
    },
    {
      title: "Amended Leave",
      dataIndex: "having_cancel_request",
      key: "having_cancel_request",
      width: "10%",
      sorter: (a, b) => a.having_cancel_request.localeCompare(b.having_cancel_request),
      render: (having_cancel_request) => {
        if (having_cancel_request === "1") {
          return "Yes";
        } else {
          return "No";
        }
      },
    },
    {
      title: "Applied On",
      dataIndex: "applied_date",
      key: "applied_date",
      width: "10%",
      sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
      render: (_, record) => {
        const dateFormat = moment(record.created_at).format("DD MMM YYYY");
        return dateFormat;
      },
    },
  ];

  const CSVHeaders = [
    { label: "SI NO", key: "Employee ID" },
    { label: "Name", key: "Name" },
    { label: "Available Leaves", key: "Available Leaves" },
    { label: "Consumed Leaves", key: "Consumed Leaves" },
    { label: "Carry Forward", key: "Carry Forward" },
    { label: "Total Leaves", key: "Total Leaves" },
  ];

  console.log(leaveSummary, "afsefe")

  const getFilteredLeaveSummaryForCSV = () => {
    if (!Array.isArray(leaveSummary)) return [];

    return leaveSummary.map((leave) => {
      let available = 0;
      let consumed = 0;
      let carryForward = 0;

      availableConsumed?.forEach((item) => {
        if (String(item.leaveCategoryId) !== String(leave.id)) return;

        available += item.available ?? 0;
        consumed += item.consumed ?? 0;
        carryForward += item.carryforward ?? 0;
      });

      return {
        id: leave.id,
        categoryName: leave.categoryName,
        available,
        consumed,
        carryForward,
        total: available + carryForward,
      };
    });
  };

  console.log(leaveSummary, "leaveSummaryleaveSummary")

  const prepareCSV = (event, done) => {
    if (!leaveSummary.length) {
      message.warning("No data available");
      done(false);
      return;
    }


    const csvData = leaveSummary.map((leave) => ({
      "Employee ID": leave.id, // leave category id
      Name: leave.categoryName,
      "Available Leaves": leave.available,
      "Consumed Leaves": leave.consumed,
      "Carry Forward": leave.carryforward,
      "Total Leaves": leave.available + leave.carryforward,
    }));

    setCSVDepartmentLeave(csvData);
    done(true);
  };

  // if (
  //   Menulist?.find((item) => item?.key === "approvals" && item?.permission.edit)
  // ) {
  //   columns.push({
  //     title: "Action",
  //     dataIndex: "address",
  //     key: "address",
  //     width: "10%",
  //     render: (_, record) => (
  //       <>
  //         <Tooltip title="View Leave">
  //           <EyeFilled
  //             className="action-button"
  //             onClick={() => viewLeave(record, true)}
  //           />
  //         </Tooltip>
  //         {(userRoleId === 1 || userRoleId === 6) && (
  //           <Tooltip title="Remind HOD & Assistant HOD" placement="left">
  //             <BellFilled
  //               className="action-button"
  //               onClick={() => remindSuperior(record)}
  //             />
  //           </Tooltip>
  //         )}
  //       </>
  //     ),
  //   });
  // }

  const filterleavereport = leaveList.filter(
    // (item) => item.status_id === "4" && item.department_id == selectedDepartment
    (item) => {
      const findUser = userList?.find((user) => {
        return user.userid === item?.userid;
      });
      if (filteruser[0]?.OfficeSupervisorId === "none" || userInfo?.roleId === "2") {
        return item;
      } else {
        const isSameCountry = some(findUser?.managingoffice, (value) =>
          includes(filteruser[0]?.managingoffice, value)
        );
        return isSameCountry;
      }
    }
  );

  const viewLeave = (leaveObject, isViewOnly = false) => {
    if (
      Menulist?.find(
        (item) => item?.key === "approvals" && item?.permission.edit
      )
    ) {
      toggleDisplayLeaveModal(true);
      setLeaveDetails({
        ...leaveObject,
        isViewOnly,
      });
    }
  };

  const remindSuperior = (leaveRecord) => {
    const { confirm } = Modal;
    confirm({
      icon: "",
      closable: true,
      content:
        "Do you want to send reminder notification to HOD & Assistant HOD?",
      async onOk() {
        const { user_leave_id, user_id } = leaveRecord;
        const { code } = await CALL_API(
          "leave-notification-to-hod-assistant-hod",
          "post",
          {
            user_leave_id,
            user_id,
          }
        );
        if (code === STATUS_CODE.SUCCESS) {
          message.success(`Notification has been sent.`);
        } else {
          message.error(`Something went wrong. Please try again.`);
        }
      },
      onCancel() { },
    });
  };

  if (loadingRoute) {
    return (
      <StyledLoader>
        <div>
          <Spin size="large" />
        </div>
      </StyledLoader>
    );
  }

  const uniquemanagingOffice = uniqBy(
    crmManagingOfficeList?.map((item) => {
      return { label: item?.Label, value: item?.Value };
    }),
    "value"
  );

  const getLeaveDataFromAvailableConsumed = (categoryId) => {
    const leave = leaveSummary.find(
      (item) => String(item.id) === String(categoryId)
    );

    if (!leave) {
      return {
        chartData: [
          { type: "available", value: 0, carryforward: 0 },
          { type: "consumed", value: 0 },
        ],
      };
    }

    return {
      chartData: [
        {
          type: "available",
          value: leave.available,
          carryforward: leave.carryforward,
        },
        {
          type: "consumed",
          value: leave.consumed,
        },
      ],
    };
  };

  console.log(leaveSummary, "leaveSummaryleaveSummaryleaveSummary")

  return (
    <>
      <>
        <StyledRow gutter={16}>

          <Col md={24} sm={24} xs={24} xl={12}>
            <AttendanceBarChart isHrDashboard={true} employeeid={employeeid} managingoffice={selectedManagingOffice} />
          </Col>

          <Col md={24} sm={24} xs={24} xl={12}>
            <LocationBasedPresentStaff
              employeeid={employeeid}
              isHrDashboard={true}
            />
          </Col>

          {Menulist?.find(
            (item) => item?.key === "approvals" && item?.permission.view
          ) && (
              <Col
                md={24}
                sm={24}
                xs={24}
                xl={24}
                ref={containerRef}
                className="mt-2"
              >
                <StyledChartContainer>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: "10px",
                    }}
                  >
                    <StyledTitle>
                      Waiting for Approval{" "}
                      {filterleavereport?.length > 0
                        ? `(${filterleavereport?.length})`
                        : null}
                    </StyledTitle>

                    <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                      <Form form={form} layout="vertical">
                        <Form.Item name="managingoffice" >
                          {filteruser[0]?.roleid?.includes("2") &&
                            <Select
                              showSearch
                              placeholder="Select Country"
                              labelInValue
                              onChange={(val) => {
                                // val = { label: "Kenya", value: "Kenya" }
                                form.setFieldsValue({ managingoffice: val });
                                handleFormChange(val?.label);
                              }}
                            >
                              {uniqBy(
                                CountryFilterResourcePlanning?.map((item) => ({
                                  label: item.country,
                                  value: item.country,
                                })),
                                "value"
                              )?.map((option) => (
                                <Select.Option key={option.value} value={option.value}>
                                  {option.label}
                                </Select.Option>
                              ))}
                            </Select>

                          }
                        </Form.Item>
                      </Form>
                    </Col>
                  </div>
                  <Spin spinning={displayTaskLoader}>
                    <StyledTable
                      dataSource={filterleavereport}
                      columns={columns}
                      rowClassName={(record, index) =>
                        index % 2 === 0 ? "" : "non-white"
                      }
                      onRow={(record) => {
                        return {
                          onClick: () => viewLeave(record, true),
                        };
                      }}
                      rowKey="user_leave_id"
                      pagination={
                        filterleavereport.length > 10 ? paginationOptions : false
                      }
                    />
                  </Spin>
                  <LeaveFormModel
                    isModalVisible={displayLeaveModal}
                    closeModal={() => toggleDisplayLeaveModal(false)}
                    userRoleId={userRoleId}
                    leaveDetails={leaveDetails}
                    toggleDisplayLeaveModal={toggleDisplayLeaveModal}
                    getLeaveList={getLeaveList}
                    setIsModalOpen={setIsModalOpen}
                    setLeaveID={setLeaveID}
                    setLeaveUserId={setLeaveUserId}
                    sethavingCancel={sethavingCancel}
                    ClientId={ClientId}
                  />
                </StyledChartContainer>
              </Col>
            )}

          <Col md={24} sm={24} xs={24} xl={24} className="mt-2">
            <Spin spinning={displayLeaveReportLoader}>
              <StyledLeaveContainer>
                <Row justify="space-between" align="middle">
                  <Col>
                    <StyledTitle className="mb-3">Overall Leave Report</StyledTitle>
                  </Col>
                  <Col className="mb-2"
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <CSVLink
                      headers={CSVHeaders}
                      data={CSVDepartmentLeave}
                      filename="Overall Leave Report.csv"
                      asyncOnClick={true}
                      onClick={prepareCSV}
                      ref={csvLinkDepartment}
                    >
                      <ButtonOutlined
                        disabled={
                          !Array.isArray(leaveSummary) || leaveSummary.length === 0
                        }
                      >
                        Export CSV file
                      </ButtonOutlined>
                    </CSVLink>

                    {filteruser[0]?.roleid?.includes("2") && (
                      <Form form={form} layout="vertical" style={{ marginBottom: 0 }}>
                        <Form.Item name="managingoffice1" style={{ marginBottom: 0 }}>
                          <Select
                            showSearch
                            placeholder="Select Country"
                            labelInValue
                            style={{ width: 200 }}
                            onChange={(val) => {
                              form.setFieldsValue({ managingoffice: val });
                              handleFormChangeLeave(val.label);
                            }}
                          >
                            {uniqBy(
                              CountryFilterResourcePlanning?.map((item) => ({
                                label: item.country,
                                value: item.country,
                              })),
                              "value"
                            )?.map((option) => (
                              <Select.Option
                                key={option.value}
                                value={option.value}
                                label={option.label}
                              >
                                {option.label}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Form>
                    )}
                  </Col>

                </Row>


                <Row
                  gutter={{
                    xs: 8,
                    sm: 12,
                    md: 16,
                  }}
                >
                  {Array.isArray(leaveSummary) &&
                    leaveSummary.map((value, index) => (
                      <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={12}
                        xl={8}
                        key={value.categoryName}
                        onClick={() =>
                          openDetailWindow(value.categoryName, value.id)
                        }
                      >
                        {(() => {
                          const { chartData } = getLeaveDataFromAvailableConsumed(value.id);

                          return (
                            <LeaveDonutChart
                              iconName={LEAVE_ICON[7]}
                              title={value.categoryName}
                              data={chartData}        // ✅ from availableConsumed
                              color={getColor(index)}
                              carryForward={value.carryforward}
                            />
                          );
                        })()}

                      </Col>
                    ))}
                </Row>
              </StyledLeaveContainer>
            </Spin>
          </Col>
        </StyledRow>
      </>
      <Modal
        title="Approve leave"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            No
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={handleOk}
          >
            Yes
          </Button>,
        ]}
      >
        <p>Are you sure you want to approve leave?</p>
      </Modal>

      <DepartmentStaffLeaveBalance
        displayModal={staffDepartmentLeaveModal}
        toggleModal={() => toggleStaffDepartmentLeaveModal(false)}
        leaveTypeId={selectedLeaveTypeId}
        selectedDepartmentId={selectedDepartmentId}
        leaveName={selectedLeaveType}
        leaveList={leaveList}
        leaveCategoryList={leaveCategoryList}
        leaveCatgeory={leaveCatgeory}
        all={false}
        availableConsumed={availableConsumed}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  loadingRoute: getLoadingRoute(state),
  locationList: getLocations(state),
});

export default connect(mapStateToProps, null)(HrDashboard);